import React from 'react';
import PropTypes from 'prop-types';
import { connectHitsPerPage } from 'react-instantsearch-dom';

const HitsPerPage = ({ items, currentRefinement, defaultRefinement, refine }) => (
  <div className="form-inline">
    <select
      className="form-control form-control-sm flex-shrink-1 pr-40"
      onChange={event => {
        event.preventDefault();
        refine(event.target.value);
      }}
      value={currentRefinement ?? defaultRefinement}
    >
      {items.map(item => (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  </div>
);

HitsPerPage.propTypes = {
  currentRefinement: PropTypes.number,
  defaultRefinement: PropTypes.number,
  items: PropTypes.array,
  refine: PropTypes.func,
};

HitsPerPage.defaultProps = {
  currentRefinement: undefined,
  defaultRefinement: 10,
  items: [
    { value: 10, label: 'Toon 10 resultaten' },
    { value: 20, label: 'Toon 20 resultaten' },
    { value: 50, label: 'Toon 50 resultaten' },
  ],
  refine: undefined,
};

export default connectHitsPerPage(HitsPerPage);
